import { Utilities } from "../helpers/utilities";
import { userServices } from "./user.service";

export const commonServices = {
    handleResponse,
    handleError,
    generatePassword,
};

function handleResponse(response) {
    return new Promise((resolve, reject) => {
        if (response.ok) {
            // return json if it was returned in the response
            var contentType = response.headers.get("content-type");
            if (contentType && contentType.includes("application/json")) {
                response.json().then(json => resolve(json));
            } else {
                response.text().then(text => {
                    resolve(text);
                });
            }
        } else {
            // return error message from response body
            if(response.status===401){
                userServices.logout();
            }
            response.text().then(text => {
                var errorText="";
                if(response.status===404){
                    errorText= "Not found " + text;
                }
                else{
                    var errorObject=Utilities.JsonTryParse(text);
                    if(errorObject!=null){
                        for (let key in errorObject) {
                            errorText+=errorObject[key] + '; ';
                        }
                    }
                    else{
                        errorText = text;
                    }
                }
                reject(errorText);
            });
        }
    });
}

function handleError(error) {
    return Promise.reject(error && error.message);
}

function generatePassword(){
    var specials = '!@)(';
    var lowercase = 'abcdefghijklmnopqrstuvwxyz';
    var uppercase = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    var numbers = '0123456789';

    String.prototype.pick = function(min, max) {
        var n, chars = '';

        if (typeof max === 'undefined') {
            n = min;
        } else {
            n = min + Math.floor(Math.random() * (max - min));
        }

        for (var i = 0; i < n; i++) {
            chars += this.charAt(Math.floor(Math.random() * this.length));
        }

        return chars;
    };

    String.prototype.shuffle = function() {
        var array = this.split('');
        var tmp, current, top = array.length;

        if (top) while (--top) {
            current = Math.floor(Math.random() * (top + 1));
            tmp = array[current];
            array[current] = array[top];
            array[top] = tmp;
        }

        return array.join('');
    };

    return (specials.pick(1) + lowercase.pick(3) + uppercase.pick(3) + numbers.pick(3)).shuffle();

}


// WEBPACK FOOTER //
// ./src/services/common.service.js